import { Component } from '@angular/core';
import { CobaltButtonComponent } from '@cae/cobalt-angular/components/button';
import { CobaltModalActionsDirective, CobaltModalContentDirective, CobaltModalRef, CobaltModalTitleDirective } from '@cae/cobalt-angular/components/modal';
import { AuthB2CService } from 'common-web-core';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-session-experation-dialog',
  templateUrl: './session-experation-dialog.component.html',
  styleUrls: ['./session-experation-dialog.component.less'],
  standalone: true,
  imports: [
    CobaltButtonComponent,
    CobaltModalActionsDirective,
    CobaltModalContentDirective,
    CobaltModalTitleDirective,
  ]
})
export class SessionExperationDialogComponent {
  constructor(
    public modalgRef: CobaltModalRef<AppComponent>,
    private authB2cService: AuthB2CService
  ) { }

  public loginClick(): void {
    sessionStorage.clear();
    this.authB2cService.logout();
    this.modalgRef.close();
  }
}
